import type { ServiceRecord } from '../../types';
import { getEventTypeLabels } from '../getEventTypeLabels';
import { getServiceRecordTarget } from '../getServiceRecordTarget';
import { getUnitFormatters } from '../getUnitFormatters';

import { getCalibrationKindLabels } from 'pages/MaintenancePage/components/LogServicePanel/helpers/getCalibrationKindLabels';
import { getPartLabels } from 'pages/MaintenancePage/components/ServiceIntervalConfigPanel/helpers/getPartLabels';

type ServiceRecordSummaryStrings = Parameters<typeof getCalibrationKindLabels>[0] &
    Parameters<typeof getEventTypeLabels>[0] &
    Parameters<typeof getPartLabels>[0] &
    Parameters<typeof getUnitFormatters>[0] & {
        EM_DASH: string;
        SERVICE_RECORD_SUMMARY: (params: { event: string; target: string }) => string;
    };

// The one-line record summary ("Replaced · Motor 3") shared by the history row
// and the record detail header.
export const getServiceRecordSummary = ({
    record,
    strings
}: {
    record: ServiceRecord;
    strings: ServiceRecordSummaryStrings;
}): string => {
    const eventLabels = getEventTypeLabels(strings);
    const target = getServiceRecordTarget({
        calibrationKindLabels: getCalibrationKindLabels(strings),
        emDash: strings.EM_DASH,
        partLabels: getPartLabels(strings),
        record,
        unitFormatters: getUnitFormatters(strings)
    });

    return strings.SERVICE_RECORD_SUMMARY({ event: eventLabels[record.eventType], target });
};
